import Product from './Product';

export default class DynamicProduct extends Product {}
